import { FEATURE_FLAGS } from '@/lib/featureFlags';

export function isFounderSystemVisible(user?: { email?: string }): boolean {
  if (!FEATURE_FLAGS.FOUNDER_SYSTEM_ENABLED) return false;
  if (FEATURE_FLAGS.FOUNDER_SYSTEM_ADMIN_ONLY) {
    const adminEmails = ['nathanael@douevenlift.com'];
    return adminEmails.includes(user?.email ?? '');
  }
  return true;
}
